import SimulationCreatePage from './SimulationCreatePage';

export default SimulationCreatePage;
